/**
 * 県えらびの「日本地図」（タイル地図）。
 *
 * 1県 = 1マスで、だいたいの位置に並べた地図。正確な形より「自分の県がすぐ見つかる」ことと、
 * メダルの色で全国の進み具合がひと目で分かることを優先している。
 * 47行の文字リストだと、自分の県まで4画面スクロールが要った。
 */

/** regionId -> [列, 行]。12列 × 12行。 */
export const TILE_POSITIONS: Readonly<Record<string, readonly [number, number]>> = {
  hokkaido: [11, 0],
  aomori: [11, 1],
  akita: [10, 2],
  iwate: [11, 2],
  yamagata: [10, 3],
  miyagi: [11, 3],
  ishikawa: [7, 4],
  toyama: [8, 4],
  niigata: [9, 4],
  fukushima: [10, 4],
  fukui: [6, 5],
  gifu: [7, 5],
  nagano: [8, 5],
  gunma: [9, 5],
  tochigi: [10, 5],
  shimane: [2, 6],
  tottori: [3, 6],
  hyogo: [4, 6],
  kyoto: [5, 6],
  shiga: [6, 6],
  aichi: [7, 6],
  yamanashi: [8, 6],
  saitama: [9, 6],
  ibaraki: [10, 6],
  yamaguchi: [1, 7],
  hiroshima: [2, 7],
  okayama: [3, 7],
  osaka: [4, 7],
  nara: [5, 7],
  mie: [6, 7],
  shizuoka: [7, 7],
  kanagawa: [8, 7],
  tokyo: [9, 7],
  chiba: [10, 7],
  fukuoka: [0, 8],
  oita: [1, 8],
  ehime: [2, 8],
  kagawa: [3, 8],
  tokushima: [4, 8],
  wakayama: [5, 8],
  saga: [0, 9],
  kumamoto: [1, 9],
  miyazaki: [2, 9],
  kochi: [3, 9],
  nagasaki: [0, 10],
  kagoshima: [1, 10],
  okinawa: [0, 11],
};

export const TILE_COLUMNS = 12;
export const TILE_ROWS = 12;
